import { useEffect, useState } from 'react';
import { apiErrorHandling } from '../api/apierrorhandling';
import { getMangoPayAccountInformation } from '../api/pmApi';
import { MangoPayAccount } from '../models';
import { generalStore } from '../stores/GeneralStore';

export const useMangoAccountInfo = (mangopayId: string | null, walletId: string | null, refresher?: boolean) => {
  const [mangoPayAccount, setMangoPayAccount] = useState<MangoPayAccount | null>(null);
  useEffect(() => {
    const load = async (mangopayId: string, walletId: string) => {
      generalStore.setIsLoading(true);
      try {
        const response = (await getMangoPayAccountInformation(mangopayId, walletId)).data;
        setMangoPayAccount(response.data);
      } catch (error: any) {
        apiErrorHandling(error);
      } finally {
        generalStore.setIsLoading(false);
      }
    };
    if (mangopayId && walletId) {
      load(mangopayId, walletId);
    }
  }, [mangopayId, refresher]);

  return mangoPayAccount;
};
